import React, { useEffect, useState } from 'react';
import './LoaderStyles.scss';
import classNames from 'classnames';
import { addZero, useUpdatePeriod } from '../../../utils/utils';

const loadingTime = 5 * 60 * 1000;

export default function Timer({ hideScreen = false, global = false }) {
  const [prevValue, setPrevValue] = useState(false);
  const [endTime, setEndTime] = useState(new Date().getTime());
  const [diff, setDiff] = useState(0);
  const [percent, setPercent] = useState(0);
  const [currentTime, setCurrentTime] = useState(new Date().getTime());

  const getEndTime = () => new Date().getTime() + loadingTime;

  const calculate = () => {
    setCurrentTime(new Date().getTime());
  };

  const [setPeriod] = useUpdatePeriod(calculate, 0.3, true);
  useEffect(() => {
    setPeriod(0.3);
    setEndTime(getEndTime());
    setPercent(0);
  }, []);
  useEffect(() => {
    let nd = endTime - currentTime;
    if (nd <= 0) {
      const e = getEndTime();
      setEndTime(e);
      nd = e - currentTime;
    }
    setPercent(Math.ceil((loadingTime / nd) * 100) - 100);
    setDiff(nd);
  }, [currentTime, endTime]);

  const secSum = Math.ceil(diff / 1000);
  const min = Math.floor(secSum / 60);
  const sec = Math.ceil(secSum % 60);

  return (
    <div className={classNames('time-loader-wrapper', { 'hide-screen': hideScreen }, { global })}>
      <div className="time-loader-block">
        <div className="time-loader-text">
          До окончания процесса обработки
        </div>
        <div className="time-loader-line">
          <div className="search-information-loader">
            <div className="search-information-loader-line" style={{ '--progress-width': `${percent}%` }} />
          </div>
          <div className="time-loader-time">
            {addZero(2, min)}:{addZero(2, sec)}
          </div>
        </div>
      </div>
    </div>
  );
}
